import { render, staticRenderFns } from "./app-swiper.vue?vue&type=template&id=904b8c2a&"
import script from "./app-swiper.vue?vue&type=script&lang=js&"
export * from "./app-swiper.vue?vue&type=script&lang=js&"
import style0 from "./app-swiper.vue?vue&type=style&index=0&id=904b8c2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports